import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { solarizedlight } from 'react-syntax-highlighter/dist/esm/styles/prism';
import databaseService from '../services/databaseService';
import Footer from './Footer';

function ArchivePost() {
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const { post_title } = useParams();

  useEffect(() => {
    const loadPost = async () => {
      if (!post_title) return;

      try {
        await databaseService.init();
        const route = `/archives/${post_title}`;
        const archivePost = await databaseService.getArchiveByRoute(route);

        if (archivePost) {
          setPost(archivePost);
        } else {
          setPost({ error: 'Archive post not found' });
        }
      } catch (error) {
        console.error("Failed to load archive post:", error);
        setPost({ error: 'Failed to load archive post' });
      } finally {
        setLoading(false);
      }
    };

    loadPost();
  }, [post_title]);

  if (loading) return <div>Loading...</div>;
  if (post?.error) return <div>{post.error}</div>;
  if (!post) return <div>Post not found</div>;

  // Helper function to render content
  const renderContent = (content) => {
    if (typeof content === 'string') {
      if (content.includes('<') && content.includes('>')) {
        return <span dangerouslySetInnerHTML={{ __html: content }} />;
      }
      return (
        <ReactMarkdown
          components={{
            code({node, inline, className, children, ...props}) {
              const match = /language-(\w+)/.exec(className || '')
              return !inline && match ? (
                <SyntaxHighlighter
                  style={solarizedlight}
                  language={match[1]}
                  PreTag="div"
                  {...props}
                >
                  {String(children).replace(/\n$/, '')}
                </SyntaxHighlighter>
              ) : (
                <code className={className} {...props}>
                  {children}
                </code>
              )
            }
          }}
        >
          {content}
        </ReactMarkdown>
      );
    }
    return content;
  };

  return (
    <div className="content-wrapper">
      <div className="post-header">
        <h1>{post.title}</h1>
        <div className="post-meta">
          <span className="post-date">{new Date(post.date).toLocaleDateString()}</span>
        </div>
      </div>
      
      <div className="post-content">
        {renderContent(post.content)}
      </div>

      <Footer />
    </div>
  );
}

export default ArchivePost;
